import React, { useState } from 'react';

//import Spinner from './Spinner';
import Plantilla from './plantillas/Plantilla'
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { TextField, Typography } from '@mui/material'
import Form from 'react-bootstrap/Form';
import ErrorModal, { useErrorHandling } from './ErrorModal';
import Spinner from './Spinner';
import useForm from '../hooks/useForm'
import { generateFormat } from '../api/index'

const Formato = ({ studentInfo, programa, onCancelar }) => {
    const { error, clearError } = useErrorHandling('FUI-001');
    const [showSpinner, setShowSpinner] = useState(false);

    let programaSeleccionado = studentInfo?.grados?.filter(x => x.programaKey === programa);

    if (programaSeleccionado && programaSeleccionado.length > 0) programaSeleccionado = programaSeleccionado[0];

    const [beca, setBeca] = useState(programaSeleccionado?.data?.beca);
    const [trabaja, setTrabaja] = useState(programaSeleccionado?.data?.trabaja);
    const [apoyoGobierno, setApoyoGobierno] = useState(programaSeleccionado?.data?.apoyoGobierno);
    const [apoyoPrivado, setApoyoPrivado] = useState(programaSeleccionado?.data?.apoyoPrivado);
    const [sueldo, setSueldo] = useState(programaSeleccionado?.data?.sueldo);
    const [ingresoFamiliar, setIngresoFamiliar] = useState(programaSeleccionado?.data?.ingresoFamiliar);

    const getFreshModel = () => ({
        matricula: studentInfo?.matricula || '',
        aPaterno: studentInfo?.aPaterno || '',
        aMaterno: studentInfo?.aMaterno || '',
        nombre: studentInfo?.nombre || '',
        fechaNacimiento: studentInfo?.fechaNacimiento || '',
        estadoCivil: studentInfo?.estadoCivil || '',
        sexo: studentInfo?.sexo || '',
        curp: studentInfo?.curp || '',
        nacionalidad: studentInfo?.nacionalidad || '',
        codigoPostal: studentInfo?.codigoPostal || '',
        celular: studentInfo?.celular || '',
        telCasa: studentInfo?.telCasa || '',
        otroTel: studentInfo?.otroTel || '',
        correo: studentInfo?.correo || '',
        correoInst: studentInfo?.correoInst || '',
        telefonoTutor: studentInfo?.telefonoTutor || '',
        correoTutor: studentInfo?.correoTutor || '',

        gradoKey: programaSeleccionado?.gradoKey || '',
        noGrado: programaSeleccionado?.noGrado || '',
        campusKey: programaSeleccionado?.campusKey || '',
        campus: programaSeleccionado?.campus || '',
        grado: programaSeleccionado?.grado || '',
        programaKey: programaSeleccionado?.programaKey || '',
        programa: programaSeleccionado?.programa || '',
        cicloKey: programaSeleccionado?.cicloKey || '',
        ciclo: programaSeleccionado?.ciclo || '',
        tipoIngreso: programaSeleccionado?.tipoIngreso || '',
        categoria: programaSeleccionado?.categoria || '',
        temporalidad: programaSeleccionado?.temporalidad || '',
        procedencia: programaSeleccionado?.procedencia || '',
        promedio: programaSeleccionado?.promedio || '',

        tipoDescuento: programaSeleccionado?.descuentos?.length > 0 ? programaSeleccionado.descuentos[0].tipoDescuento : '',
        aplicaA: programaSeleccionado?.descuentos?.length > 0 ? programaSeleccionado.descuentos[0].aplicaA : '',
        descuento: programaSeleccionado?.descuentos?.length > 0 ? programaSeleccionado.descuentos[0].descuento : '0',

        descuentos: programaSeleccionado?.descuentos || [],

        domicilio: programaSeleccionado?.data?.domicilio || '',
        colonia: programaSeleccionado?.data?.colonia || '',
        municipio: programaSeleccionado?.data?.municipio || '',
        entidad: programaSeleccionado?.data?.entidad || '',
        tipoEscuela: programaSeleccionado?.data?.tipoEscuela || '',
        empresa: programaSeleccionado?.data?.empresa || '',
        puesto: programaSeleccionado?.data?.puesto || '',
        tipoBeca: programaSeleccionado?.data?.tipoBeca || '',
        tipoApoyoGobierno: programaSeleccionado?.data?.tipoApoyoGobierno || '',
        tipoApoyoPrivado: programaSeleccionado?.data?.tipoApoyoPrivado || '',
        contactoNombre: programaSeleccionado?.data?.contactoNombre || '',
        contactoTelefono: programaSeleccionado?.data?.contactoTelefono || '',
        contactoCorreo: programaSeleccionado?.data?.contactoCorreo || '',
        tutorNombre: programaSeleccionado?.data?.tutorNombre || '',
        tutorTelefono: programaSeleccionado?.data?.tutorTelefono || '',
        tutorCorreo: programaSeleccionado?.data?.tutorCorreo || '',
    })

    const {
        handleInputChange,
        values
    } = useForm(getFreshModel);

    if (!studentInfo) return null;

    const handleCancelar = () => {
        onCancelar();
    };

    const handleSueldoChange = (event) => {
        const newValue = Number(event.target.value);
        if (!isNaN(newValue)) {
            setSueldo(newValue);
        }
    };

    const handleIngresoChange = (event) => {
        const newValue = Number(event.target.value);
        if (!isNaN(newValue)) {
            setIngresoFamiliar(newValue);
        }
    };

    const handleGenerar = () => {
        setShowSpinner(true);

        const studentInformationRequest = {
            matricula: values.matricula,
            aPaterno: values.aPaterno,
            aMaterno: values.aMaterno,
            nombre: values.nombre,
            fechaNacimiento: values.fechaNacimiento,
            estadoCivil: values.estadoCivil,
            sexo: values.sexo,
            curp: values.curp,
            nacionalidad: values.nacionalidad,
            codigoPostal: values.codigoPostal,
            celular: values.celular,
            telCasa: values.telCasa,
            otroTel: values.otroTel,
            correo: values.correo,
            correoInst: values.correoInst,
            telefonoTutor: values.telefonoTutor,
            correoTutor: values.correoTutor,

            gradoKey: values.gradoKey,
            noGrado: values.noGrado,
            campusKey: values.campusKey,
            campus: values.campus,
            grado: values.grado,
            programaKey: values.programaKey,
            programa: values.programa,
            cicloKey: values.cicloKey,
            ciclo: values.ciclo,
            tipoIngreso: values.tipoIngreso,
            categoria: values.categoria,
            temporalidad: values.temporalidad,
            procedencia: values.procedencia,
            promedio: values.promedio,
            descuentos: values.descuentos,

            tipoDescuento: values.tipoDescuento,
            aplicaA: values.aplicaA,
            descuento: values.descuento,

            domicilio: values.domicilio,
            colonia: values.colonia,
            municipio: values.municipio,
            entidad: values.entidad,
            tipoEscuela: values.tipoEscuela,
            trabaja: trabaja,
            empresa: values.empresa,
            puesto: values.puesto,
            sueldo: sueldo,
            beca: beca,
            tipoBeca: values.tipoBeca,
            apoyoGobierno: apoyoGobierno,
            tipoApoyoGobierno: values.tipoApoyoGobierno,
            apoyoPrivado: apoyoPrivado,
            tipoApoyoPrivado: values.tipoApoyoPrivado,
            ingresoFamiliar: ingresoFamiliar,
            contactoNombre: values.contactoNombre,
            contactoTelefono: values.contactoTelefono,
            contactoCorreo: values.contactoCorreo,
            tutorNombre: values.tutorNombre,
            tutorTelefono: values.tutorTelefono,
            tutorCorreo: values.tutorCorreo,
        }

        generateFormat(studentInformationRequest);
        return setShowSpinner(false);
    };

    return (<>
        <div className="container">
            <Plantilla id="Formato" />
            <ErrorModal error={error} onClose={clearError} />
            <Spinner show={showSpinner} />

            <div>
                {/*Datos del Alumno*/}
                <Accordion defaultExpanded="true">
                    <AccordionSummary
                        expandIcon={<ArrowDownwardIcon />}
                        aria-controls="panel1-content"
                        id="datosAlumno"
                        style={{background: 'lightblue'}}
                    >
                        <Typography component="span" style={{ fontWeight: 'bold'}}>Datos Alumno</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Matricula"
                                    name="matricula"
                                    value={studentInfo.matricula}
                                    variant="outlined"
                                    disabled
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Nombre"
                                    name="nombre"
                                    value={studentInfo.nombre}
                                    variant="outlined"
                                    disabled
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Ap. Paterno"
                                    name="apaterno"
                                    value={studentInfo.aPaterno}
                                    variant="outlined"
                                    disabled
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Ap. Materno"
                                    name="amaterno"
                                    value={studentInfo.aMaterno}
                                    variant="outlined"
                                    disabled
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="CURP"
                                    name="curp"
                                    value={studentInfo.curp}
                                    variant="outlined"
                                    disabled
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Fecha de Nacimiento"
                                    name="fechanacimiento"
                                    value={studentInfo.fechaNacimiento}
                                    variant="outlined"
                                    disabled
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Estado Civil"
                                    name="estadocivil"
                                    value={studentInfo.estadoCivil}
                                    variant="outlined"
                                    disabled
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Sexo"
                                    name="sexo"
                                    value={studentInfo.sexo}
                                    variant="outlined"
                                    disabled
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Nacionalidad"
                                    name="nacionalidad"
                                    value={studentInfo.nacionalidad}
                                    variant="outlined"
                                    disabled
                                />
                            </Col>
                        </Row>
                    </AccordionDetails>
                </Accordion>

                {/*Datos del Adicionales*/}
                <Accordion defaultExpanded="true">
                    <AccordionSummary
                        expandIcon={<ArrowDownwardIcon />}
                        aria-controls="panel1-content"
                        id="datosAdicionales"
                        style={{ background: 'lightblue' }}
                    >
                        <Typography component="span" style={{ fontWeight: 'bold' }}>Datos Adicionales</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Código Postal"
                                    name="codigopostal"
                                    value={studentInfo.codigoPostal}
                                    variant="outlined"
                                    disabled
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Celular"
                                    name="celular"
                                    value={studentInfo.celular}
                                    variant="outlined"
                                    disabled
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Teléfono Casa"
                                    name="telcasa"
                                    value={studentInfo.telCasa}
                                    variant="outlined"
                                    disabled
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Teléfono Otro"
                                    name="telotro"
                                    value={studentInfo.otroTel}
                                    variant="outlined"
                                    disabled
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Correo"
                                    name="correo"
                                    value={studentInfo.correo}
                                    variant="outlined"
                                    disabled
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Correo Institucional"
                                    name="correoInstitucional"
                                    value={studentInfo.correoInst}
                                    variant="outlined"
                                    disabled
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Teléfono Tutor"
                                    name="telTutor"
                                    value={studentInfo.telefonoTutor}
                                    variant="outlined"
                                    disabled
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Correo Adicional"
                                    name="correoTutor"
                                    value={studentInfo.correoTutor}
                                    variant="outlined"
                                    disabled
                                />
                            </Col>
                        </Row>
                    </AccordionDetails>
                </Accordion>

                {/*Datos Académicos*/}
                <Accordion defaultExpanded="true">
                    <AccordionSummary
                        expandIcon={<ArrowDownwardIcon />}
                        aria-controls="panel1-content"
                        id="datosAcademicos"
                        style={{ background: 'lightblue' }}
                    >
                        <Typography component="span" style={{ fontWeight: 'bold' }}>Datos Académicos</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Campus"
                                    name="campus"
                                    value={programaSeleccionado?.campus}
                                    variant="outlined"
                                    disabled
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Nivel"
                                    name="nivel"
                                    value={programaSeleccionado?.grado}
                                    variant="outlined"
                                    disabled
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Programa"
                                    name="programa"
                                    value={programaSeleccionado?.programa}
                                    variant="outlined"
                                    disabled
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Ciclo"
                                    name="ciclo"
                                    value={programaSeleccionado?.ciclo}
                                    variant="outlined"
                                    disabled
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Tipo de Ingreso"
                                    name="tipoIngreso"
                                    value={programaSeleccionado?.tipoIngreso}
                                    variant="outlined"
                                    disabled
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Procedencia"
                                    name="procedencia"
                                    value={values.procedencia}
                                    variant="outlined"
                                    onChange={handleInputChange}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Promedio"
                                    name="promedio"
                                    value={values.promedio}
                                    variant="outlined"
                                    onChange={handleInputChange}
                                />
                            </Col>
                        </Row>
                    </AccordionDetails>
                </Accordion>

                {/* Descuentos */}
                { programaSeleccionado?.descuentos?.length > 0 && (
                    <Accordion defaultExpanded="true">
                        <AccordionSummary
                            expandIcon={<ArrowDownwardIcon />}
                            aria-controls="panel1-content"
                            id="descuentos"
                            style={{ background: 'lightblue' }}
                        >
                            <Typography component="span" style={{ fontWeight: 'bold' }}>Descuentos</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            {programaSeleccionado.descuentos.map((item, j) => (
                                <>
                                    <Row className="mb-3 mt-4">
                                        <Col className="d-grid gap-2">
                                            <TextField
                                                label="Tipo de Descuento"
                                                name="tipoDescuento"
                                                key={j}
                                                value={item.tipoDescuento}
                                                variant="outlined"
                                                disabled
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mb-3 mt-4">
                                        <Col className="d-grid gap-2">
                                            <TextField
                                                label="Aplica A"
                                                name="AplicaA"
                                                key={j}
                                                value={item.aplicaA}
                                                variant="outlined"
                                                disabled
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mb-3 mt-4">
                                        <Col className="d-grid gap-2">
                                            <TextField
                                                label="Descuento"
                                                name="descuento"
                                                key={j}
                                                value={item.descuento}
                                                variant="outlined"
                                                disabled
                                            />
                                        </Col>
                                    </Row>
                                </>
                           ))}
                        </AccordionDetails>
                    </Accordion>
                )}

                {/* DATOS MANUALES */}
                {/* Domicilio */}
                <Accordion defaultExpanded="true">
                    <AccordionSummary
                        expandIcon={<ArrowDownwardIcon />}
                        aria-controls="panel1-content"
                        id="datosDomicilio"
                        style={{ background: 'lightblue' }}
                    >
                        <Typography component="span" style={{ fontWeight: 'bold' }}>Domicilio</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Calle"
                                    name="domicilio"
                                    value={values.domicilio}
                                    variant="outlined"
                                    onChange={handleInputChange}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Colonia"
                                    name="colonia"
                                    value={values.colonia}
                                    variant="outlined"
                                    onChange={handleInputChange}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Municipio"
                                    name="municipio"
                                    value={values.municipio}
                                    variant="outlined"
                                    onChange={handleInputChange}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Entidad"
                                    name="entidad"
                                    value={values.entidad}
                                    variant="outlined"
                                    onChange={handleInputChange}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Tipo de Escuela"
                                    name="tipoEscuela"
                                    value={values.tipoEscuela}
                                    variant="outlined"
                                    onChange={handleInputChange}
                                />
                            </Col>
                        </Row>
                    </AccordionDetails>
                </Accordion>

                {/* Laboral */}
                <Accordion defaultExpanded="true">
                    <AccordionSummary
                        expandIcon={<ArrowDownwardIcon />}
                        aria-controls="panel1-content"
                        id="datosLaboral"
                        style={{ background: 'lightblue' }}
                    >
                        <Typography component="span" style={{ fontWeight: 'bold' }}>Laboral</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <Form.Check
                                    defaultChecked={trabaja}
                                    label="¿Trabaja?"
                                    name="trabaja"
                                    value={trabaja}
                                    variant="outlined"
                                    onChange={(e) => {setTrabaja(e.target.checked)}}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Empresa"
                                    name="empresa"
                                    value={values.empresa}
                                    variant="outlined"
                                    onChange={handleInputChange}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Puesto"
                                    name="puesto"
                                    value={values.puesto}
                                    variant="outlined"
                                    onChange={handleInputChange}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Sueldo"
                                    name="sueldo"
                                    value={sueldo}
                                    variant="outlined"
                                    onChange={handleSueldoChange}
                                />
                            </Col>
                        </Row>
                    </AccordionDetails>
                </Accordion>

                {/* Apoyos */}
                <Accordion defaultExpanded="true">
                    <AccordionSummary
                        expandIcon={<ArrowDownwardIcon />}
                        aria-controls="panel1-content"
                        id="datosApoyos"
                        style={{ background: 'lightblue' }}
                    >
                        <Typography component="span" style={{ fontWeight: 'bold' }}>Apoyos</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <Form.Check
                                    defaultChecked={beca}
                                    label="¿Beca?"
                                    name="beca"
                                    value={beca}
                                    variant="outlined"
                                    onChange={(e) => {setBeca(e.target.checked)}}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Tipo de Beca"
                                    name="tipoBeca"
                                    value={values.tipoBeca}
                                    variant="outlined"
                                    onChange={handleInputChange}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <Form.Check
                                    defaultChecked={apoyoGobierno}
                                    label="¿Apoyo Gobierno?"
                                    name="apoyoGobierno"
                                    value={apoyoGobierno}
                                    variant="outlined"
                                    onChange={(e) => {setApoyoGobierno(e.target.checked)}}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Tipo de Apoyo Gobierno"
                                    name="tipoApoyoGobierno"
                                    value={values.tipoApoyoGobierno}
                                    variant="outlined"
                                    onChange={handleInputChange}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <Form.Check
                                    defaultChecked={apoyoPrivado}
                                    label="¿Apoyo Privado?"
                                    name="apoyoPrivado"
                                    value={apoyoPrivado}
                                    variant="outlined"
                                    onChange={(e) => { setApoyoPrivado(e.target.checked) }}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Tipo de Apoyo Privado"
                                    name="tipoApoyoPrivado"
                                    value={values.tipoApoyoPrivado}
                                    variant="outlined"
                                    onChange={handleInputChange}
                                />
                            </Col>
                        </Row>
                    </AccordionDetails>
                </Accordion>

                {/* Familiares */}
                <Accordion defaultExpanded="true">
                    <AccordionSummary
                        expandIcon={<ArrowDownwardIcon />}
                        aria-controls="panel1-content"
                        id="datosContacto"
                        style={{ background: 'lightblue' }}
                    >
                        <Typography component="span" style={{ fontWeight: 'bold' }}>Contacto</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Ingreso Familiar"
                                    name="ingresoFamiliar"
                                    value={ingresoFamiliar}
                                    variant="outlined"
                                    onChange={handleIngresoChange}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Nombre Contacto"
                                    name="contactoNombre"
                                    value={values.contactoNombre}
                                    variant="outlined"
                                    onChange={handleInputChange}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Teléfono Contacto"
                                    name="contactoTelefono"
                                    value={values.contactoTelefono}
                                    variant="outlined"
                                    onChange={handleInputChange}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Correo Contacto"
                                    name="contactoCorreo"
                                    value={values.contactoCorreo}
                                    variant="outlined"
                                    onChange={handleInputChange}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Nombre Tutor"
                                    name="tutorNombre"
                                    value={values.tutorNombre}
                                    variant="outlined"
                                    onChange={handleInputChange}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Teléfono Tutor"
                                    name="tutorTelefono"
                                    value={values.tutorTelefono}
                                    variant="outlined"
                                    onChange={handleInputChange}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3 mt-4">
                            <Col className="d-grid gap-2">
                                <TextField
                                    label="Correo Tutor"
                                    name="tutorCorreo"
                                    value={values.tutorCorreo}
                                    variant="outlined"
                                    onChange={handleInputChange}
                                />
                            </Col>
                        </Row>
                    </AccordionDetails>
                </Accordion>
            </div>

            <Row className="mb-3 mt-4">
                <Col className="d-grid gap-2">
                    <Button variant="primary" onClick={handleGenerar}>Generar PDF</Button>
                </Col>
            </Row >
            <Row className="mb-3 mt-4">
                <Col className="d-grid gap-2">
                    <Button variant="primary" onClick={handleCancelar}>Regresar</Button>
                </Col>
            </Row >
        </div>
    </>);
}

export default Formato;